import { NULL_EXPR } from "@angular/compiler/src/output/output_ast";
import { FormControl, FormGroup, Validators } from "@angular/forms";

export class UserModel{
    id : string;
    userName : string;
    email : string;
    phoneNumber : string;
    fullName : string;
    role : string;
    countryCode:string;

    public static getFormGroup()
    {
        var form = new FormGroup({
            
            id: new FormControl(''),
            userName: new FormControl('',Validators.required),
            email : new FormControl('', [Validators.required, Validators.email]),
            phoneNumber: new FormControl(null),
            fullName : new FormControl('', Validators.required),
            role : new FormControl('', Validators.required),
            countryCode:new FormControl('', Validators.required)
    
        });

        return form;

    }

    public static initializeFormGroup(form){
   
        return form.setValue({
            id : null,
            userName : null,
            email : null,
            phoneNumber :null,
            fullName : null,
            role : null,
            countryCode : null
        });
      
    }
}   